import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImpersonationComponent } from './impersonation.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: ImpersonationComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    FormsModule,
    NgbModule,
  ],
  declarations: [ImpersonationComponent],
})
export class ImpersonationModule {}
